import { createContext, useContext, useEffect, useState } from "react";

const ThemeCtx = createContext({ theme: "dark", toggle: () => {} });
export const useTheme = () => useContext(ThemeCtx);

function getThemeCookie() {
  try {
    const match = document.cookie.match(/(?:^|;\s*)guebly_theme=(dark|light)/);
    return match ? match[1] : null;
  } catch { return null; }
}

function writeThemeCookie(mode) {
  try {
    document.cookie = `guebly_theme=${mode}; domain=.guebly.com.br; path=/; max-age=31536000; SameSite=Lax`;
  } catch {}
}

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    if (typeof window === "undefined") return "dark";

    // 1. URL param (highest priority — set by guebly.com.br link)
    const url = new URL(window.location.href);
    const param = url.searchParams.get("theme");
    if (param === "dark" || param === "light") {
      localStorage.setItem("guebly:theme", param);
      writeThemeCookie(param);
      url.searchParams.delete("theme");
      window.history.replaceState({}, "", url.toString());
      return param;
    }

    // 2. Cross-subdomain cookie (set by guebly.com.br theme toggle)
    const cookie = getThemeCookie();
    if (cookie) {
      localStorage.setItem("guebly:theme", cookie);
      return cookie;
    }

    // 3. Local storage fallback
    return localStorage.getItem("guebly:theme") || "dark";
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
  }, [theme]);

  const toggle = () => {
    setTheme((t) => {
      const next = t === "dark" ? "light" : "dark";
      localStorage.setItem("guebly:theme", next);
      writeThemeCookie(next);
      return next;
    });
  };

  return <ThemeCtx.Provider value={{ theme, toggle }}>{children}</ThemeCtx.Provider>;
}
